import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from "react";
import { Form, Input, Row, Col, Card, Table, Typography, Button, InputNumber, Popconfirm, Space, Select, Modal, DatePicker, AutoComplete, Collapse, Tabs, Upload, Radio, } from "antd";
import TextArea from "antd/es/input/TextArea";
import { QuotationService } from "../../../Services/Manage/QuotationService";
import { ServicetypeService } from "../../../Services/Manage/ServicetypeService";
import { Tooltip } from "antd";
import useMessage from "antd/es/message/useMessage";
import { LetterService } from "../../../Services/Manage/LetterService";
import Title from "antd/es/skeleton/Title";
import { ENDPOINT } from "../../../Services/ENDPOINT";
import { UserService } from "../../../Services/Manage/UserService";
import { BankService } from "../../../Services/Manage/BankService";
import AddBankData from "../../../Pages/Manage/BankDetails/AddBankData";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import CreatePayment from "../../modals/CreatePayment";
import QuotationProfessionalTemplate from "../template/QuotationProfessionalTemplate";
import QuotationInvoiceTemplate from "../template/QuotationInvoiceTemplate";
import QuotationInvoiceTemplateV2 from "../template/QuotationInvoiceTemplateV2";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import {
  DeleteOutlined,
  PlusOutlined,
  EditOutlined,
  UserOutlined,
  InfoCircleOutlined,
  UnorderedListOutlined,
  BarChartOutlined,
  SafetyCertificateOutlined,
  WalletOutlined,
  BankOutlined,
  FileTextOutlined


} from "@ant-design/icons";
import { Flex } from "antd";
import { Divider } from "antd";



const scopeQuillModules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ align: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    ["link"],
    ["clean"],
  ],
};


const AddQuotationData = forwardRef(({
  Eqslected,
  enquiryList,
  data,
  selectedDate,
  setSelectedDate,
  eqData,
  handleGetDatabyEqid,
  customerForm,
  validDate,
  followDate,
  quotationStatus,
  preparedBy,
  assignedTo,

}, ref) => {

  const { Text, Title } = Typography;
  const [paymentTerm, setPaymentTerm] = useState("50_advance");
  const [customPaymentTerm, setCustomPaymentTerm] = useState("");
  const [customPaymentOptions, setCustomPaymentOptions] = useState([]);
  const [notesToCustomer, setNotesToCustomer] = useState("");

  const customerNotesRef = useRef(null);

  const [exclusions, setExclusions] = useState("");
  const [assumptions, setAssumptions] = useState("");
  const [supportWarranty, setSupportWarranty] = useState("");
  const [internalNotes, setInternalNotes] = useState("");
  const [customerNotes, setCustomerNotes] = useState("");
  const [activeTab, setActiveTab] = useState("scope");
  const [deliveryTimeline, setDeliveryTimeline] = useState("");

  //edit of term & condition 
  const [tcContent, setTcContent] = useState("");
  const [tcModalOpen, setTcModalOpen] = useState(false);
  const [tempTcContent, setTempTcContent] = useState("");
  const [documentFiles, setDocumentFiles] = useState([]);

  const limitRichText = (value, setter) => {
    const plainText = value
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

    const pointCount = (value.match(/<li/g) || []).length;

    if (plainText.length > 344) {
      message.warning("Maximum 344 characters allowed");
      return;
    }

    if (pointCount > 6) {
      message.warning("Maximum 6 bullet points allowed");
      return;
    }

    setter(value);
  };

  //document
  const handleDocumentRemove = (file) => {
    setDocumentFiles((prev) =>
      prev.filter((item) => item.uid !== file.uid)
    );
  };


  const SummaryLine = ({ label, value }) => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 6,
        lineHeight: 1.3,
      }}
    >
      <Typography.Text
        style={{
          color: "#6b7280",
          fontSize: 13,
        }}
      >
        {label}
      </Typography.Text>

      <Typography.Text
        style={{
          fontSize: 13,
          fontWeight: 500,
          color: "#111827",
        }}
      >
        ₹ {Number(value || 0).toLocaleString("en-IN")}
      </Typography.Text>
    </div>
  );



  const renderItem = (eqId, name, status) => (
    <Flex align="center" justify="space-between" style={{ width: "100%" }}>
      <span>{eqId}</span>
      <span>
        <UserOutlined /> {name}
        {status ? ` — ${status}` : ""}
      </span>
    </Flex>
  );


  const grouped = (enquiryList || []).reduce((acc, item) => {
    if (!acc[item.service_id]) {
      acc[item.service_id] = {
        service_name: item.service_name,
        items: [],
      };
    }

    acc[item.service_id].items.push(item);
    return acc;
  }, {});





  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);

  //section
  const [sections, setSections] = useState([]);

  const [count, setCount] = useState(3);
  const [grandTotal, setGrandTotal] = useState(0);
  const [message, msgContc] = useMessage();
  const [letterHead, setLetterHead] = useState([]);
  const [orgDetails, setOrgDetails] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedTC, setSelectedTC] = useState([]);
  const [selectedTCOption, setSelectedTCOption] = useState([]);
  const [dgSign, setDGsign] = useState(null);
  const [dgSignOption, setDGsignOption] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [editedTCContent, setEditedTCContent] = useState("");
  const [bankAc, setBankAc] = useState(null);
  const [bankAcOption, setBankAcOption] = useState([]);
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [bankInitialValues, setBankInitialValues] = useState(null);

  const navigate = useNavigate();
  const [options, setOptions] = useState([]);

  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [quotationNo, setQuotationNo] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [summaryDiscount, setSummaryDiscount] = useState(0);

  const [scope, setScope] = useState("");
  const [title, setTitle] = useState("");
  const [descOptions, setDescOptions] = useState([]);
  const [descSearch, setDescSearch] = useState("");
  const { Option, OptGroup } = Select;



const [followUps, setFollowUps] = useState([]);
  const importedEqIdRef = useRef(null);

  const [followUpInput, setFollowUpInput] = useState({
    date: null,
    follow_up_type: null,
    summary: "",
  });

  const followUpTypeOptions = [
    { value: "Call", label: "Call" },
    { value: "Email", label: "Email" },
    { value: "Meeting", label: "Meeting" },
    { value: "Demo", label: "Demo" },
  ];


  const handlePreview = () => {
    if (selectedValue) {
      setIsModalOpen(true);
    }
  };



  const getAllLetterhead = async () => {
    try {
      const request = await LetterService.getAllHead();
      setLetterHead(
        request.data.map((item, index) => ({
          label: item.tag,
          value: item.id,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);

    }
  };

  const taxOptions = ["GST", "VAT", "Service Tax", "Excise", "Custom Duty"];
  const handleSearch = (value) => {
    setOptions(
      value
        ? taxOptions
          .filter((tax) => tax.toLowerCase().includes(value.toLowerCase()))
          .map((tax) => ({ value: tax }))
        : []
    );
  };

  const getBankAcOption = async () => {
    try {
      const request = await BankService.getAllBank();
      setBankAcOption(
        request.data.map((item, index) => ({
          label: item.tag,
          value: item.id,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);

    }
  };

  const handleOpenAddBank = (initial = null) => {
    setBankInitialValues(initial);
    setBankModalOpen(true);
  };

  const handleBankSubmit = async (values) => {
    try {
      const payload = { ...values };

      let res;
      if (payload.id) {
        res = await BankService.updateBank(payload, payload.id);
      } else {
        res = await BankService.createBank(payload);
      }

      if (res && res.status) {
        message.success(res.message || "Bank saved");
        setBankModalOpen(false);
        await getBankAcOption();

        // select newly created/updated bank if returned
        const newId = res.data?.id || payload.id;
        const idx = (bankAcOption || []).find((o) => Number(o.value) === Number(newId));
        if (idx) setBankAc(idx);
      } else {
        message.error(res?.message || "Failed to save bank");
      }
    } catch (err) {
      console.error(err);
      message.error("Bank save failed");
    }


  };

  const getAllTCData = async () => {
    try {
      const response = await LetterService.getAllTC();
      setSelectedTCOption(
        response.data.map((item, index) => ({
          label: item.tag,
          value: item.id,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getDigitalSign = async () => {
    try {
      const response = await QuotationService.getDigitalSign();
      setDGsignOption(
        response.data.map((item) => ({
          label: (
            <img
              src={`${ENDPOINT.base}/${item.image_path}`}
              alt={`Signature ${item.id}`}
              style={{ width: "100px", height: "auto", objectFit: "contain" }}
            />
          ),
          value: item.id,
          title: `Signature ${item.id}`,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const buildDescOptions = async () => {
    try {
      const [prodRes, servRes, catRes] = await Promise.all([
        ServicetypeService.getAllProducts(),
        ServicetypeService.getAllServices(),
        ServicetypeService.getAllProductCat(),
      ]);
      const products = prodRes?.data || [];
      const services = servRes?.data || [];
      const cats = catRes?.data || [];

      const catMap = {};
      cats.forEach((c) => { catMap[String(c.id)] = c.name; });
      const prodGroups = {};
      products.forEach((p) => {
        const catName = catMap[String(p.cat_id)] || "Uncategorized";
        if (!prodGroups[catName]) prodGroups[catName] = [];
        prodGroups[catName].push({
          label: `${p.name}${p.sku ? ` (${p.sku})` : ""}`,
          value: `prod-${p.id}`,
          desc: p.name,
          hsn: p.sku || "",
          unit: p.unit || "",
          price: Number(p.unit_price) || 0,
          title: `Product: ${p.name}\nHSN/SAC: ${p.sku || "-"}\nUnit: ${p.unit || "-"}\nCategory: ${catName}\nUnit Price: ${p.unit_price || 0}`,
        });
      });
      const productOptionGroups = Object.keys(prodGroups).map((catName) => ({
        label: `Product — ${catName}`,
        options: prodGroups[catName],
      }));
      const serviceOptions = {
        label: "Services",
        options: services.map((s) => ({
          label: `${s.service_name}${s.service_code ? ` (${s.service_code})` : ""}`,
          value: `serv-${s.id}`,
          desc: s.service_name,
          hsn: "",
          unit: "",
          price: Number(s.unit_price) || 0,
          title: `Service: ${s.service_name}\nCode: ${s.service_code || "-"}\nUnit Price: ${s.unit_price || 0}`,
        })),
      };
      setDescOptions([...productOptionGroups, serviceOptions]);
    } catch (e) {
      console.error(e);
    }
  };



  useEffect(() => {
    if (!data?.quotation_data?.length) return;

    const groupedSections = {};

    data.quotation_data.forEach((item) => {
      const section = item.section_name || "General";

      if (!groupedSections[section]) {
        groupedSections[section] = [];
      }

      groupedSections[section].push({
        ...item,
        key: item.id || Date.now() + Math.random(),
      });
    });

    setDataSource(groupedSections["General"] || []);

    setSections(
      Object.keys(groupedSections)
        .filter((s) => s !== "General")
        .map((section) => ({
          key: `section-${Date.now()}-${section}`,
          title: section,
          rows: groupedSections[section],
        }))
    );
  }, [data]);



  const getOrgDetails = async () => {
    try {
      const res = await LetterService.getAllFooter();
      setOrgDetails((res.data || [])[0] || null);
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    getAllLetterhead();
    getAllTCData();
    getBankAcOption();
    getDigitalSign();
    buildDescOptions();
    getOrgDetails();
    form.setFieldsValue({
      quotationNo: data,
    });
  }, [data, form]);

  {/* useEffect(() => {
    if (!eqData) return;

    if (eqData?.scope !== undefined && eqData?.scope !== null) {
        setScope(eqData.scope);
    }

    const parseItems = (items) => {
        if (Array.isArray(items)) return items;

        try {
            return JSON.parse(items || "[]");
        } catch {
            return [];
        }
    };

    const serviceItems = parseItems(eqData.service_items);
    const productItems = parseItems(eqData.product_items);

    console.log("EQ DATA =>", eqData);

    console.log("SERVICE ITEMS =>", serviceItems);
    console.log("PRODUCT ITEMS =>", productItems);

    const serviceRows = serviceItems.map((item, index) => ({
  key: `service-${index}`,
  service_name: item.service_name || "",
  description: item.description || item.service_description || "",
  qty: Number(item.qty || 1),
  unit: item.unit || item.service_unit || "No",
  duration: item.duration || "-",
  unitprice: Number(item.unit_price || 0),
  discount: Number(item.discount || 0),
  tax: Number(item.tax || item.gst || 18),
  totalprice: Number(item.unit_price || 0),
}));

const productRows = productItems.map((item, index) => ({
  key: `product-${index}`,
  service_name: item.product_name || "",
  description: item.description || item.product_description || "",
  qty: Number(item.qty || 1),
  unit: item.unit || item.product_unit || "No",
  duration: item.duration || "-",
  unitprice: Number(item.unit_price || 0),
  discount: Number(item.discount || 0),
  tax: Number(item.tax || item.gst || 18),
  totalprice: Number(item.unit_price || 0),
}));

    const rows = [...serviceRows, ...productRows];

    if (rows.length > 0) {
        setDataSource(rows);
        setCount(rows.length + 1);
    }
}, [eqData]);  */}

  useEffect(() => {
    if (!eqData) return;

    if (eqData?.scope !== undefined && eqData?.scope !== null) {
      setScope(eqData.scope);
    }



  }, [eqData]);

useEffect(() => {
    const currentEqId = eqData?.eq_id || eqData?.qu_no;
    if (!currentEqId || importedEqIdRef.current === currentEqId) return;

    const parseItems = (items) => {
      if (Array.isArray(items)) return items;
      try { return JSON.parse(items || "[]"); } catch { return []; }
    };

    const calculateTotal = (item) => {
      const qty = Number(item.qty || item.quantity || 1);
      const rate = Number(item.unit_price || item.price || item.rate || 0);
      const discount = Number(item.discount || 0);
      const tax = Number(item.tax || item.gst || 0);
      const base = qty * rate;
      const discountAmount = (base * discount) / 100;
      const taxable = base - discountAmount;
      const taxAmount = (taxable * tax) / 100;
      return Math.round(taxable + taxAmount);
    };

    const serviceItems = parseItems(eqData?.service_items);
    const productItems = parseItems(eqData?.product_items);

    const serviceRows = serviceItems.map((item, index) => ({
      key: `service-${index}`,
      service_name: item.service_name || item.name || "",
      description: item.description || item.service_description || "",
      hsn_code: item.hsn_code || item.service_code || "",
      qty: Number(item.qty || item.quantity || 1),
      unit: item.unit || "No",
      duration: item.duration || "",
      unitprice: Number(item.unit_price || item.price || item.rate || 0),
      discount: Number(item.discount || 0),
      tax: Number(item.tax || item.gst || 0),
      totalprice: calculateTotal(item),
    }));

    const productRows = productItems.map((item, index) => ({
      key: `product-${index}`,
      service_name: item.product_name || item.name || "",
      description: item.description || item.product_description || "",
      hsn_code: item.hsn_code || item.sku || item.code_name || "",
      qty: Number(item.qty || item.quantity || 1),
      unit: item.unit || "No",
      duration: item.duration || "",
      unitprice: Number(item.unit_price || item.price || item.rate || 0),
      discount: Number(item.discount || 0),
      tax: Number(item.tax || item.gst || 0),
      totalprice: calculateTotal(item),
    }));

    const rows = [...serviceRows, ...productRows];

    if (rows.length > 0) {
      setDataSource(rows);
      setCount(rows.length + 1);
    }

    importedEqIdRef.current = currentEqId;
  }, [eqData?.eq_id, eqData?.qu_no, eqData?.service_items, eqData?.product_items]);



  const numberToWords = (num) => {
    const a = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
      "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];
    const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const g = ["", "Thousand", "Million", "Billion"];

    if (num === 0) return "Zero";

    let str = "";
    let grp = 0;

    while (num > 0) {
      let chunk = num % 1000;
      if (chunk) {
        let chunkStr = "";
        if (chunk > 99) {
          chunkStr += a[Math.floor(chunk / 100)] + " Hundred ";
          chunk %= 100;
        }
        if (chunk > 19) {
          chunkStr += b[Math.floor(chunk / 10)] + " ";
          chunk %= 10;
        }
        if (chunk > 0) chunkStr += a[chunk] + " ";
        str = chunkStr + g[grp] + " " + str;
      }
      num = Math.floor(num / 1000);
      grp++;
    }
    return str.trim();
  };

  useEffect(() => {
    const total = allRows.reduce(
      (sum, item) => sum + Number(item.totalprice || 0),
      0
    );

    setGrandTotal(total);
  }, [dataSource, sections]);

  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };

  const handleChange = (key, field, value) => {
    const newData = dataSource.map((item) => {
      if (item.key === key) {
        const updatedItem = { ...item, [field]: value };

        const basePrice =
          Number(updatedItem.qty || 0) * Number(updatedItem.unitprice || 0);

        const discountAmount =
          (basePrice * Number(updatedItem.discount || 0)) / 100;

        const taxableAmount = basePrice - discountAmount;

        const taxAmount =
          (taxableAmount * Number(updatedItem.tax || 0)) / 100;

        updatedItem.totalprice = Math.round(taxableAmount + taxAmount);

        return updatedItem;
      }

      return item;
    });

    setDataSource(newData);
  };


  const calculateGrandTotal = () => {
    const total = dataSource.reduce((sum, item) => sum + item.totalprice, 0);
    setGrandTotal(total);
  };

  const handleAddPayment = async () => {
    try {
      const request = form.getFieldsValue();


      // save quotationNo and open modal
      setQuotationNo(request.quotationNo);
      setPaymentModalOpen(true);
    } catch (error) {
      console.error("Error in handleAddPayment:", error);
    }
  };

  const showHsnColumn = dataSource.some(
    (item) => String(item.hsn_code || "").trim() !== ""
  );



  const importFromEnquiry = () => {
    if (!eqData) {
      message.warning("Please select enquiry first");
      return;
    }

    const parseItems = (items) => {
      if (Array.isArray(items)) return items;
      try {
        return JSON.parse(items || "[]");
      } catch {
        return [];
      }
    };

    const calculateTotal = (item) => {
      const qty = Number(item.qty || item.quantity || 1);
      const rate = Number(item.unit_price || item.price || item.rate || 0);
      const discount = Number(item.discount || 0);
      const tax = Number(item.tax || item.gst || 18);

      const base = qty * rate;
      const discountAmount = (base * discount) / 100;
      const taxable = base - discountAmount;
      const taxAmount = (taxable * tax) / 100;

      return Math.round(taxable + taxAmount);
    };

    const serviceItems = parseItems(eqData.service_items);
    const productItems = parseItems(eqData.product_items);

    const serviceRows = serviceItems.map((item, index) => ({
      key: `service-${Date.now()}-${index}`,
      service_name: item.service_name || item.name || "",
      description: item.description || item.service_description || "",
      hsn_code: item.hsn_code || item.service_code || "",
      qty: Number(item.qty || item.quantity || 1),
      unit: item.unit || item.service_unit || "No",
      duration: item.duration || "",
      unitprice: Number(item.unit_price || item.price || item.rate || 0),
      discount: Number(item.discount || 0),
      tax: Number(item.tax || item.gst || 0),
      totalprice: calculateTotal(item),
    }));

    const productRows = productItems.map((item, index) => ({
      key: `product-${Date.now()}-${index}`,
      service_name: item.product_name || item.name || "",
      description: item.description || item.product_description || "",
      hsn_code: item.hsn_code || item.sku || item.code_name || "",
      qty: Number(item.qty || item.quantity || 1),
      unit: item.unit || item.product_unit || "No",
      duration: item.duration || "",
      unitprice: Number(item.unit_price || item.price || item.rate || 0),
      discount: Number(item.discount || 0),
      tax: Number(item.tax || item.gst || 0),
      totalprice: calculateTotal(item),
    }));

    const rows = [...serviceRows, ...productRows];

    if (!rows.length) {
      message.warning("No service/product data found in selected enquiry");
      return;
    }

    setDataSource(rows);
    setCount(rows.length + 1);
    message.success("Enquiry items imported");
  };



  const handleSectionChange = (sectionKey, rowKey, field, value) => {
    setSections((prev) =>
      prev.map((section) => {
        if (section.key !== sectionKey) return section;

        return {
          ...section,
          rows: section.rows.map((row) => {
            if (row.key !== rowKey) return row;

            const updated = { ...row, [field]: value };

            const base = Number(updated.qty || 0) * Number(updated.unitprice || 0);
            const discountAmount = (base * Number(updated.discount || 0)) / 100;
            const taxable = base - discountAmount;
            const taxAmount = (taxable * Number(updated.tax || 0)) / 100;

            return {
              ...updated,
              totalprice: Math.round(taxable + taxAmount),
            };
          }),
        };
      })
    );
  };


  const columns = [
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>#</span>,
      dataIndex: "key",
      width: 15,
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Item / Service</span>,
      dataIndex: "service_name",
      key: "service_name",
      width: 205,
      render: (text, record) => (
        <AutoComplete
          style={{ width: "100%" }}
          options={getFilteredDescOptions()}
          value={text}
          placeholder="Type product / service"
          filterOption={false}
          onSearch={(val) => setDescSearch(val)}
          onFocus={() => setDescSearch("")}
          onSelect={(val, option) => {
            setDescSearch("");
            handleSelectDesc(record.key, val, option);
          }}
          onChange={(val) => {
            setDescSearch(val);
            handleChange(record.key, "service_name", val);
          }}
        >
          <TextArea
            value={text}
            autoSize={{ minRows: 1, maxRows: 3 }}
            style={{ resize: "none", fontSize: 13 }}
          />
        </AutoComplete>
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Description</span>,
      dataIndex: "description",
      key: "description",
      width: 180,
      render: (text, record) => (
        <TextArea
          value={text}
          autoSize={{ minRows: 1, maxRows: 3 }}
          style={{ resize: "none", fontSize: 13 }}
          onChange={(e) =>
            handleChange(record.key, "description", e.target.value)
          }
        />
      ),
    },

    ...(showHsnColumn
      ? [
        {
          title: <span style={{ fontSize: 12, fontWeight: 600 }}>HSN</span>,
          dataIndex: "hsn_code",
          width: 58,
          align: "center",
          render: (text, record) => (
            <Input
              size="small"
              value={text}
              style={{ width: "100%" }}
              onChange={(e) =>
                handleChange(record.key, "hsn_code", e.target.value)
              }
            />
          ),
        },
      ]
      : []),

    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Qty</span>,
      dataIndex: "qty",
      width: 45,
      align: "center",
      render: (text, record) => (
        <InputNumber
          size="small"
          min={0}
          controls={false}
          value={text}
          style={{ width: "100%" }}
          onChange={(value) => handleChange(record.key, "qty", value)}
        />
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Unit</span>,
      dataIndex: "unit",
      width: 55,
      align: "center",
      render: (text, record) => (
        <Input
          size="small"
          value={text}
          onChange={(e) => handleChange(record.key, "unit", e.target.value)}
        />
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Duration</span>,
      dataIndex: "duration",
      width: 60,
      align: "center",
      render: (text, record) => (
        <Input
          size="small"
          value={text}
          placeholder=" "
          onChange={(e) => handleChange(record.key, "duration", e.target.value)}
        />
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Rate</span>,
      dataIndex: "unitprice",
      width: 70,
      align: "right",
      render: (text, record) => (
        <InputNumber
          size="small"
          min={0}
          controls={false}
          value={text}
          style={{ width: "100%" }}
          onChange={(value) => handleChange(record.key, "unitprice", value)}
        />
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Discount %</span>,
      dataIndex: "discount",
      width: 55,
      align: "center",
      render: (text, record) => (
        <InputNumber
          size="small"
          min={0}
          max={100}
          controls={false}
          value={text}
          style={{ width: "100%" }}
          onChange={(value) => handleChange(record.key, "discount", value)}
        />
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Tax %</span>,
      dataIndex: "tax",
      width: 52,
      align: "center",
      render: (text, record) => (
        <InputNumber
          size="small"
          min={0}
          controls={false}
          value={text}
          style={{ width: "100%" }}
          onChange={(value) => handleChange(record.key, "tax", value)}
        />
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Amount</span>,
      dataIndex: "totalprice",
      width: 68,
      align: "right",
      render: (text) => (
        <Typography.Text strong style={{ fontSize: 12 }}>
          {Number(text || 0).toLocaleString("en-IN")}
        </Typography.Text>
      ),
    },
    {
      title: <span style={{ fontSize: 12, fontWeight: 600 }}>Action</span>,
      key: "action",
      width: 62,
      align: "center",
      render: (_, record) => (
        <Space size={0}>
          <Button type="text" size="small" icon={<EditOutlined />} />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record.key)}
          >
            <Button type="text" size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];



  const handleSectionSelectDesc = (sectionKey, rowKey, val, option) => {
    setSections((prev) =>
      prev.map((section) => {
        if (section.key !== sectionKey) return section;

        return {
          ...section,
          rows: section.rows.map((row) => {
            if (row.key !== rowKey) return row;

            const updated = {
              ...row,
              service_name: option?.desc ?? row.service_name,
              description: option?.description ?? row.description,
              hsn_code: option?.hsn ?? row.hsn_code,
              unit: option?.unit ?? row.unit,
              unitprice: option?.price ?? row.unitprice,
            };

            const base = Number(updated.qty || 0) * Number(updated.unitprice || 0);
            const discountAmount = (base * Number(updated.discount || 0)) / 100;
            const taxable = base - discountAmount;
            const taxAmount = (taxable * Number(updated.tax || 0)) / 100;

            return {
              ...updated,
              totalprice: Math.round(taxable + taxAmount),
            };
          }),
        };
      })
    );
  };


  const handleSectionDelete = (sectionKey, rowKey) => {
    setSections((prev) =>
      prev.map((section) => {
        if (section.key !== sectionKey) return section;

        return {
          ...section,
          rows: section.rows.filter((row) => row.key !== rowKey),
        };
      })
    );
  };





  const getSectionColumns = (sectionKey) =>
    columns.map((col) => {
      if (col.key === "action") {
        return {
          ...col,
          render: (_, record) => (
            <Space size={0}>
              <Button type="text" size="small" icon={<EditOutlined />} />

              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => handleSectionDelete(sectionKey, record.key)}
              >
                <Button type="text" size="small" danger icon={<DeleteOutlined />} />
              </Popconfirm>
            </Space>
          ),
        };
      }


      if (!col.dataIndex) return col;

      if (col.dataIndex === "service_name") {


        return {
          ...col,
          render: (text, record) => (
            <AutoComplete
              style={{ width: "100%" }}
              options={getFilteredDescOptions()}
              value={text}
              placeholder="Type product / service"
              filterOption={false}
              onSearch={(val) => setDescSearch(val)}
              onFocus={() => setDescSearch("")}
              onSelect={(val, option) => {
                setDescSearch("");
                handleSectionSelectDesc(sectionKey, record.key, val, option);
              }}
              onChange={(val) =>
                handleSectionChange(sectionKey, record.key, "service_name", val)
              }
            >
              <TextArea
                value={text}
                autoSize={{ minRows: 1, maxRows: 3 }}
                style={{ resize: "none", fontSize: 13 }}
              />
            </AutoComplete>
          ),
        };
      }

      return {
        ...col,
        render: (text, record, index) => {
          if (col.dataIndex === "key") return index + 1;

          if (["description", "unit", "duration", "hsn_code"].includes(col.dataIndex)) {
            return (
              <Input
                size="small"
                value={text}
                onChange={(e) =>
                  handleSectionChange(sectionKey, record.key, col.dataIndex, e.target.value)
                }
              />
            );
          }

          if (["qty", "unitprice", "discount", "tax"].includes(col.dataIndex)) {
            return (
              <InputNumber
                size="small"
                min={0}
                controls={false}
                value={text}
                style={{ width: "100%" }}
                onChange={(value) =>
                  handleSectionChange(sectionKey, record.key, col.dataIndex, value)
                }
              />
            );
          }

          if (col.dataIndex === "totalprice") {
            return (
              <Typography.Text strong>
                {Number(text || 0).toLocaleString("en-IN")}
              </Typography.Text>
            );
          }

          return col.render ? col.render(text, record, index) : text;
        },
      };
    });


  const handleAddSection = () => {
    setSections((prev) => [
      ...prev,
      {
        key: `section-${Date.now()}`,
        title: "",
        rows: [],
      },
    ]);
  };






  const handleNewAdd = () => {
    setDataSource([
      ...dataSource,
      {
        key: count,
        service_name: "",
        description: "",
        qty: 1,
        unit: "",
        duration: "",
        unitprice: 0,
        discount: 0,
        tax: 0,
        totalprice: 0,
      },
    ]);

    setCount(count + 1);
  };

  const getFilteredDescOptions = () => {
    const q = (descSearch || "").toLowerCase().trim();
    if (!q) return descOptions;
    return descOptions
      .map((group) => {
        const opts = (group.options || []).filter((o) =>
          String(o.label || "").toLowerCase().includes(q) ||
          String(o.hsn || "").toLowerCase().includes(q)
        );
        return { ...group, options: opts };
      })
      .filter((group) => (group.options || []).length > 0);
  };

  const handleSelectDesc = (rowKey, val, option) => {
    const newData = dataSource.map((item) => {
      if (item.key === rowKey) {
        const updated = {
          ...item,
          service_name: option?.desc ?? item.service_name,
          description: option?.description ?? item.description,
          hsn_code: option?.hsn ?? item.hsn_code,
          unit: option?.unit ?? item.unit,
          unitprice: option?.price ?? item.unitprice,

        };

        const basePrice =
          Number(updated.qty || 0) * Number(updated.unitprice || 0);

        const discountAmount =
          (basePrice * Number(updated.discount || 0)) / 100;

        const taxableAmount = basePrice - discountAmount;

        const taxAmount =
          (taxableAmount * Number(updated.tax || 0)) / 100;

        updated.totalprice = Math.round(taxableAmount + taxAmount);

        return updated;
      }

      return item;
    });

    setDataSource(newData);
  };


  const handleAdd = (key) => {
    const newRow = { key: count, description: "", qty: 1, unitprice: 0, totalprice: 0 };
    const index = dataSource.findIndex((item) => item.key === key);

    let newData = [...dataSource];
    newData.splice(index + 1, 0, newRow);
    setDataSource(newData);
    setCount(count + 1);
  };




  const handleSave = async () => {

    if (isSaving) return;

    try {
      setIsSaving(true);
     

      // if (!selectedValue) {
      //     return message.warning("Please Select T & C");
      // }
      // if (!dgSign) {
      //     return message.warning("Please Select Sign");
      // }
      if (!dataSource || dataSource.length <= 0) {
        return message.warning("Please Add contents");
      }

      const request = form.getFieldsValue();
   

      const quNo = data || request.quotationNo;
      if (!quNo) {
        return message.warning("Quotation number not generated yet");
      }

      const mainRows = dataSource.map(({ key, ...rest }) => ({
        ...rest,
        hsn_code: rest.hsn_code || null,
        unit: rest.unit || null,
        qu_no: quNo,
        section_name: "General",
      }));

      const sectionRows = sections.flatMap((section) =>
        section.rows.map(({ key, ...row }) => ({
          ...row,
          hsn_code: row.hsn_code || null,
          unit: row.unit || null,
          qu_no: quNo,
          section_name: section.title || "Untitled Section",
        }))
      );



      const formattedData = [
        ...mainRows,
        ...sectionRows,
      ];





      const paymentTermLabels = {
        "100_advance": "100% Advance",
        "50_advance": "50% Advance + 50% Before Delivery",
        milestone: "Milestone Based",
      };

      let finalPaymentTerm = paymentTermLabels[paymentTerm];

      if (String(paymentTerm).startsWith("custom_")) {
        const index = Number(String(paymentTerm).replace("custom_", ""));
        finalPaymentTerm = customPaymentOptions[index] || "";
      }


      const user = await UserService.getOmeUser();
      const data_insert = {
        qu_no: quNo,
        title: title || null,
        eq_no: eqData?.eq_id || quNo,

        date: selectedDate || dayjs().format("YYYY-MM-DD"),
        valid_date: validDate || null,
        expected_close_date: followDate || null,
        quotation_status: quotationStatus || "Draft",
        sub_total: subTotal || 0,
        summary_discount: summaryDiscount || 0,
        taxable_amount: taxableAmount || 0,
        cgst_amount: cgstAmount || 0,
        sgst_amount: sgstAmount || 0,
        round_off: roundOff || 0,
        grand_total_saved: roundedTotal || 0,


        n_follow_up:
          followUps.length > 0
            ? dayjs(followUps[followUps.length - 1].date).format("YYYY-MM-DD")
            : null,

        follow_ups: followUps.map((item) => ({
          current_date: item.current_date
            ? dayjs(item.current_date).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD"),
          follow_date: item.date ? dayjs(item.date).format("YYYY-MM-DD") : null,
          follow_up_type: item.follow_up_type || null,
          summary: item.summary || "",
          follow_up_by: item.follow_up_by || null,
        })),

        tax_id: request?.tax_id,
        tax_type: request?.tax_type,

        tc_id: selectedValue?.id || null,
        tc_content: editedTCContent || "",
        // ✅ PAYMENT TERMS
        payment_terms: finalPaymentTerm,

        // ✅ NOTES
        notes_to_customer: notesToCustomer || null,
        sign_id: dgSign?.id || null,
        added_by: user.uid,
        prepared_by: preparedBy || user.name || user.uid || null,
        assigned_to: assignedTo || eqData?.assigned_to || null,
        bank_id: bankAc?.value || null,
        scope: scope || null,
        exclusions: exclusions || null,
        assumptions: assumptions || null,
        support_warranty: supportWarranty || null,
        internal_notes: internalNotes || null,
        customer_notes: customerNotes || null,
        probability: probabilityPercent || null,
        delivery_timeline: deliveryTimeline || null,
      };


      const customerValues = customerForm.getFieldsValue();
      const customerInfoPayload = {
        name: eqData?.name || null,
        company_name: eqData?.company_name || null,
        mobile_no:
          eqData?.mobile_no ||
          eqData?.contact_phone ||
          eqData?.contact_whatsapp ||
          null,
        email: eqData?.email || eqData?.contact_email || null,
        gstin: eqData?.gstin || null,
        address: eqData?.address || eqData?.location_city || null,
      };

      const requirementInfoPayload = {
        requirement: eqData?.eq_description || eqData?.summary || null,
        business_type: eqData?.industry_type || eqData?.business_type || null,
        no_of_users: eqData?.no_of_users || eqData?.number_of_employees || null,
        expected_start_date:
          eqData?.expected_start_date || eqData?.expected_go_live_date || null,
        remarks: eqData?.note || null,
        service_items: eqData?.service_items || [],
        product_items: eqData?.product_items || [],
      };

      if (!eqData?.eq_id && !customerInfoPayload.name) {
        return message.warning("Please save customer name");
      }

      if (!eqData?.eq_id && !requirementInfoPayload.requirement) {
        return message.warning("Please save requirement");
      }

      const send_both = {
        formattedData,
        quotation_insert: data_insert,

        customer_info: customerInfoPayload,
        requirement_info: requirementInfoPayload,

        // IMPORTANT: backend customer table uses this
        customer_data: !eqData?.eq_id ? customerInfoPayload : null,
      };

 

      const requests = await QuotationService.createQuotation(send_both);
    

      if (requests.status) {
        const createdQuNo = requests?.data?.qu_no;

        if (documentFiles.length > 0) {
          const fd = new FormData();

          documentFiles.forEach((file) => {
            fd.append("documents", file);
          });

          fd.append("added_by", user.uid);

          await QuotationService.uploadQuotationDocuments(
            createdQuNo,
            fd
          );
        }

        message.success(requests.message);

        await navigate("/quotation/edit", {
          state: { qu_no: createdQuNo },
        });
      } else {
        message.error(requests.message);
      }

    } catch (error) {
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };






  const getBase64Image = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        resolve(canvas.toDataURL("image/png"));
      };

      img.onerror = reject;
      img.src = url;
    });








  const handlePrintInvoice = async (templateType = "professional") => {
    try {
      const headerImageObj = letterHead.find(
        (lh) => String(lh.tag || "").toLowerCase() === "header"
      );

      const headerBase64 = headerImageObj
        ? await getBase64Image(`${ENDPOINT.base}/${headerImageObj.image_url}`)
        : "";

      const footerImageObj = letterHead.find(
        (lh) => String(lh.tag || "").toLowerCase() === "footer"
      );
      const footerBase64 = footerImageObj
        ? await getBase64Image(`${ENDPOINT.base}/${footerImageObj.image_url}`)
        : "";

      let footerAspectRatio = null;
      if (footerBase64) {
        footerAspectRatio = await new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve(img.width / img.height);
          img.onerror = () => resolve(null);
          img.src = footerBase64;
        });
      }

      let dgSignBase64 = "";
      if (dgSign) {
        dgSignBase64 = await getBase64Image(`${ENDPOINT.base}/${dgSign.image_path}`);
      }

      let dgSignAspectRatio = null;
      if (dgSignBase64) {
        dgSignAspectRatio = await new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve(img.width / img.height);
          img.onerror = () => resolve(null);
          img.src = dgSignBase64;
        });
      }

      let orgDetailsToUse = orgDetails;
      try {
        const orgRes = await LetterService.getAllFooter();
        // ADD
        orgDetailsToUse = (orgRes.data || [])[0] || orgDetails;
          // ADD
      } catch (e) {
        console.error("getAllFooter ERROR:", e);                        // CHANGED to be visible
      }

     

      const quotationData = [
        ...dataSource.map((item) => ({
          ...item,
          section_name: "General",
        })),
        ...sections.flatMap((section) =>
          section.rows.map((item) => ({
            ...item,
            section_name: section.title || "Untitled Section",
          }))
        ),
      ];

      const quotation = {
        qu_no: data,
        date: selectedDate,
        valid_date: validDate,
        expected_close_date: followDate,
        quotation_status: quotationStatus,
        revision_no: 1,
        eq_no: eqData?.eq_id || data,

        customer_name: eqData?.name,
        customer_company: eqData?.company_name,
        customer_mobile: eqData?.mobile_no || eqData?.contact_phone,
        customer_email: eqData?.email || eqData?.contact_email,
        customer_gstin: eqData?.gstin,
        customer_address: eqData?.address || eqData?.location_city,

        requirement: eqData?.eq_description || eqData?.summary,
        business_type: eqData?.industry_type || eqData?.business_type,
        no_of_users: eqData?.no_of_users || eqData?.number_of_employees,
        expected_start_date: eqData?.expected_start_date,
        requirement_remarks: eqData?.note,

        prepared_by: preparedBy,
        assigned_to: assignedTo || eqData?.assigned_to,

        scope,
        exclusions,
        support_warranty: supportWarranty,
        customer_notes: customerNotes,
        notes_to_customer: notesToCustomer,
        delivery_timeline: deliveryTimeline,
        payment_terms:
          paymentTerm === "100_advance"
            ? "100% Advance"
            : paymentTerm === "50_advance"
              ? "50% Advance + 50% Before Delivery"
              : paymentTerm === "milestone"
                ? "Milestone Based"
                : customPaymentOptions[
                Number(String(paymentTerm).replace("custom_", ""))
                ],
        tc_content: editedTCContent || selectedValue?.data || "",
      };

      const templateProps = {
        headerBase64,
        footerBase64,
        footerAspectRatio,
        dgSignBase64,
        dgSignAspectRatio,
        quotation,
        enquiry: eqData,
        quotationData,
        numberToWords,
        bankAc,
        selectedValue,
        orgDetails: orgDetailsToUse,

        type: "QUOTATION",
        paymentTermOptions: [
          "100% Advance",
          "50% Advance + 50% Before Delivery",
          "Milestone Based",
          ...customPaymentOptions,
        ],
        selectedPaymentTerm: quotation.payment_terms,
      };

  //     const pdfDoc =
  //       templateType === "professional"
  //         ? QuotationProfessionalTemplate(templateProps)
  //         : templateType === "v2"
  //           ? QuotationInvoiceTemplateV2(templateProps)
  //           : QuotationInvoiceTemplate(templateProps);

  //     pdfDoc.save(`${data || "Quotation"}.pdf`);
  //   } catch (error) {
  //     console.error(error);
  //     message.error("Failed to generate PDF");
  //   }
  // };

  // useImperativeHandle(ref, () => ({
  //   handleSave,
  //   handlePrintInvoice,
  // }));

  const pdfDoc =
        templateType === "professional"
          ? QuotationProfessionalTemplate(templateProps)
          : templateType === "v2"
            ? QuotationInvoiceTemplateV2(templateProps)
            : QuotationInvoiceTemplate(templateProps);

      pdfDoc.save(`${data || "Quotation"}.pdf`);
      return pdfDoc;
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF");
    }
  };

const handleSendQuotationEmail = async () => {
    const newTab = window.open("", "_blank");
    try {
      const pdfDoc = await handlePrintInvoice("professional");
      if (!pdfDoc) { if (newTab) newTab.close(); return; }

const toEmail = eqData?.email || eqData?.contact_email || "";
const customerName = eqData?.name || eqData?.company_name || "";
const to = encodeURIComponent(toEmail);
const subject = encodeURIComponent(`Quotation ${data}`);
const body = encodeURIComponent(
  `Hello ${customerName},\n\nPlease find attached quotation ${data}.\n\nThank you for your business.`
);
const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${subject}&body=${body}`;

      if (newTab) {
        newTab.location.href = gmailUrl;
      } else {
        window.open(gmailUrl, "_blank");
      }
      message.success("PDF downloaded — attach it in Gmail.");
    } catch (e) {
      if (newTab) newTab.close();
      console.error(e);
      message.error("Failed to send quotation.");
    }
  };

  useImperativeHandle(ref, () => ({
    handleSave,
    handlePrintInvoice,
    handleSendQuotationEmail,
  }));

  const handleClear = async () => {
    setDataSource([]);
  }


  const handleAddFollowUp = () => {
    if (!followUpInput.date && !followUpInput.follow_up_type && !followUpInput.summary) return;

    const user = JSON.parse(localStorage.getItem("ome_user") || "{}");

    setFollowUps([
      ...followUps,
      {
        current_date: dayjs().format("YYYY-MM-DD"),
        date: followUpInput.date,
        follow_up_type: followUpInput.follow_up_type,
        summary: followUpInput.summary,
        follow_up_by: user?.name || user?.user_name || user?.uid || "",
      },
    ]);

    setFollowUpInput({
      date: null,
      follow_up_type: null,
      summary: "",
    });
  };

  const allRows = [
    ...dataSource,
    ...sections.flatMap((s) => s.rows),
  ];


  const subTotal = allRows.reduce((sum, item) => {
    const qty = Number(item.qty || 0);
    const rate = Number(item.unitprice || 0);
    const discount = Number(item.discount || 0);

    const base = qty * rate;
    const discountAmount = (base * discount) / 100;

    return sum + (base - discountAmount);
  }, 0);


  const avgTax =
    dataSource.length > 0
      ? Number(dataSource[0]?.tax || 0)
      : 0;

  const cgstPercent = avgTax / 2;
  const sgstPercent = avgTax / 2;

  const taxableAmount =
    subTotal - Number(summaryDiscount || 0);
  const cgstAmount = taxableAmount * (cgstPercent / 100);
  const sgstAmount = taxableAmount * (sgstPercent / 100);


  const totalBeforeRound =
    taxableAmount + cgstAmount + sgstAmount;
  const roundedTotal = Math.round(totalBeforeRound);
  const roundOff = roundedTotal - totalBeforeRound;


  const probabilityMap = {
    Draft: 10,
    Reviewed: 10,

    Sent: 20,

    Viewed: 40,

    Negotiated: 70,

    Approved: 90,

    Converted: 100,
  };
  const probabilityPercent =
    probabilityMap[quotationStatus] || 10;

  const quotationValue = roundedTotal;
  const expectedRevenue = Math.round(
    quotationValue * (probabilityPercent / 100)
  );

  const weightedValue = Math.round(
    quotationValue * (probabilityPercent / 100)
  );


  const quotationAge = selectedDate
    ? dayjs().diff(dayjs(selectedDate), "day")
    : 0;




  const currentFollowUp =
    followUps.length > 0 ? followUps[followUps.length - 1] : null;




  return (
    <>
      <style>{`
          .scope-quill .quill {
            border: none !important;
            background: #fff;
            box-shadow: none !important;
          }

          .scope-quill .ql-toolbar.ql-snow {
            border: none !important;
            background: #fafafa;
            padding: 8px 12px;
          }

          .scope-quill .ql-container.ql-snow {
            border: none !important;
            font-size: 14px;
          }

          .scope-quill .ql-editor {
            min-height: 220px;
            padding: 14px 16px;
            line-height: 1.6;
            border: none !important;
            outline: none !important;
          }

          .scope-quill .ql-editor.ql-blank::before {
            left: 16px;
            color: #bfbfbf;
            font-style: normal;
          }

          .ant-collapse-content-box:has(.scope-quill) {
            padding: 12px !important;
          }
          `}</style>
      {msgContc}




      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={20}>
          <Card
            style={{ borderRadius: 12 }}
            bodyStyle={{ padding: "4 14px 14px 14px", }}
          >
            <div style={{ marginBottom: 14 }}>
              <Typography.Text
                strong
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: "rgba(11, 93, 148, 0.95)",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <UnorderedListOutlined style={{ marginRight: 8 }} />
                Quotation Items
              </Typography.Text>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 12,
                  gap: 12,
                  flexWrap: "wrap",
                }}
              >
                <Space wrap>
                  <Button
                    size="small"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={handleNewAdd}
                    style={{
                      backgroundColor: "rgba(11, 93, 148, 0.95)",
                      borderColor: "rgba(11, 93, 148, 0.95)",
                    }}
                  >
                    Add Item
                  </Button>

                  <Button
                    size="small"
                    icon={<PlusOutlined />}
                    onClick={handleAddSection}
                  >
                    Add Section
                  </Button>

                  <Button size="small" onClick={importFromEnquiry}>
                    Import from Enquiry
                  </Button>
                </Space>

                <Space wrap>
                  <Button
                    size="small"
                    onClick={() => setSummaryDiscount(summaryDiscount || 0)}
                  >
                    Apply Discount
                  </Button>

                  <Button
                    size="small"
                    onClick={() => {
                      setActiveTab("customer_notes");

                      setTimeout(() => {
                        customerNotesRef.current?.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                      }, 100);
                    }}
                  >
                    Add Note
                  </Button>
                </Space>
              </div>
            </div>


            <Table
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              rowKey="key"
              size="small"
              tableLayout="fixed"
            />

            <Button
              type="link"
              icon={<PlusOutlined />}
              onClick={handleNewAdd}
              style={{ marginTop: 12, paddingLeft: 0, fontSize: 12, fontWeight: 600, color: "rgba(11, 93, 148, 0.95)", }}
            >
              Add New Item
            </Button>



            {/* SECTION TABLES */}

            {sections.map((section) => (
              <div
                key={section.key}
                style={{
                  marginTop: 20,
                  border: "1px solid #f0f0f0",
                  borderRadius: 8,
                  padding: 10,
                }}
              >
                <Input
                  size="small"
                  placeholder="Enter Section Title"
                  value={section.title}
                  onChange={(e) => {
                    const value = e.target.value;

                    setSections((prev) =>
                      prev.map((sec) =>
                        sec.key === section.key
                          ? { ...sec, title: value }
                          : sec
                      )
                    );
                  }}
                  style={{
                    marginBottom: 10,
                    fontWeight: 600,
                  }}
                />

                <Table
                  dataSource={section.rows}
                  columns={getSectionColumns(section.key)}
                  pagination={false}
                  rowKey="key"
                  size="small"
                />

                <Button
                  type="link"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setSections((prev) =>
                      prev.map((sec) =>
                        sec.key === section.key
                          ? {
                            ...sec,
                            rows: [
                              ...sec.rows,
                              {
                                key: `section-row-${Date.now()}`,
                                service_name: "",
                                description: "",
                                qty: 1,
                                unit: "",
                                duration: "",
                                unitprice: 0,
                                discount: 0,
                                tax: 0,
                                totalprice: 0,
                              },
                            ],
                          }
                          : sec
                      )
                    );
                  }}
                >
                  Add Item In Section
                </Button>
              </div>
            ))}
          </Card>
        </Col>

        <Col xs={24} lg={4}>
          <Card
            title={
              <span
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                }}
              >
                Price Summary
              </span>
            }
            style={{ borderRadius: 12, height: "100%" }}
            bodyStyle={{ padding: 12 }}
            headStyle={{
              minHeight: 42,
              padding: "0 12px",
            }}
          >
            <SummaryLine label="Sub Total" value={subTotal} />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 8,
              }}
            >
              <Text style={{ fontSize: 13, color: "#6b7280" }}>
                Discount (₹)
              </Text>

              <InputNumber
                size="small"
                min={0}
                value={summaryDiscount}
                onChange={(val) => setSummaryDiscount(val || 0)}
                style={{ width: 90 }}
              />
            </div>
            <Divider style={{ margin: "8px 0" }} />
            <SummaryLine
              label="Taxable Amount"
              value={taxableAmount}
            />
            <SummaryLine
              label={`CGST (${cgstPercent}%)`}
              value={cgstAmount}
            />

            <SummaryLine
              label={`SGST (${sgstPercent}%)`}
              value={sgstAmount}
            />
            <SummaryLine label="Round Off" value={roundOff.toFixed(2)} />
            <Divider style={{ margin: "8px 0" }} />

            <div style={{ marginTop: 10 }}>
              <Text style={{ color: "#6b7280", fontWeight: 700 }}>Grand Total</Text>
              <div
                style={{
                  color: "rgba(11, 93, 148, 0.95)",
                  fontSize: 16,
                  fontWeight: 700,
                  marginTop: 6,
                }}
              >
                ₹ {roundedTotal.toLocaleString("en-IN")}
              </div>

              <Text type="secondary" style={{ display: "block", marginTop: 8 }}>
                {numberToWords(roundedTotal)} Only
              </Text>
            </div>
          </Card>
        </Col>





        {/* NEW TOP CARDS */}
        <Col xs={24}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} flex="1 1 0">
              <Card
                title={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 600,
                        color: "rgba(11, 93, 148, 0.95)",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <SafetyCertificateOutlined
                        style={{
                          marginRight: 8,
                          color: "rgba(11, 93, 148, 0.95)",
                        }}
                      />
                      Terms & Conditions
                    </span>

                    <Button
                      size="small"
                      icon={<EditOutlined />}
                      onClick={() => {
                        setTempTcContent(
                          selectedValue?.content ||
                          selectedValue?.data ||
                          selectedValue?.description ||
                          ""
                        );
                        setTcModalOpen(true);
                      }}
                    />
                  </div>
                }
                style={{ borderRadius: 12, height: "100%" }}
                headStyle={{
                  minHeight: 42,
                  padding: "0 12px",
                }}
                bodyStyle={{
                  padding: "10px 12px",
                  fontSize: 13,
                }}


              >
                <Select
                  size="small"
                  placeholder="Select Terms & Conditions"
                  value={selectedValue?.value}
                  style={{
                    width: "100%",
                    marginBottom: 10,
                  }}
                  options={selectedTCOption}
                  onChange={(value, option) => {
             
                    setSelectedValue({ ...option }); // clone (VERY IMPORTANT)

                    const content =
                      option?.content ||
                      option?.data ||
                      option?.description ||
                      "";

                    setEditedTCContent(content);

                    setSelectedValue({
                      ...option,
                      data: content,
                    });
                  }}
                />

                {selectedValue ? (
                  <div
                    style={{
                      fontSize: 13,
                      lineHeight: 1.6,
                      color: "#111827",
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `
          <style>
            ul,ol{
              margin:0;
              padding-left:18px;
            }
            li{
              margin-bottom:6px;
            }
            p{
              margin:0;
            }
          </style>
          ${editedTCContent ||
                          selectedValue.data ||
                          selectedValue.description ||
                          selectedValue.tc_description ||
                          selectedValue.terms_condition ||
                          selectedValue.content ||
                          selectedValue.details ||
                          selectedValue.terms ||
                          ""
                          }
        `,
                      }}
                    />
                  </div>
                ) : (
                  <Text type="secondary" style={{ fontSize: 13 }}>
                    Please select Terms & Conditions
                  </Text>
                )}
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8} flex="1 1 0">
              <Card
                title={
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "rgba(11, 93, 148, 0.95)",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <WalletOutlined
                      style={{
                        marginRight: 8,
                        color: "rgba(11, 93, 148, 0.95)",
                      }}
                    />
                    Payment Terms
                  </span>
                }
                style={{ borderRadius: 12, height: "100%" }}
                headStyle={{
                  minHeight: 42,
                  padding: "0 12px",
                }}
                bodyStyle={{
                  padding: "10px 12px",
                  fontSize: 13,
                }}
              >
                <Radio.Group
                  value={paymentTerm}
                  onChange={(e) => setPaymentTerm(e.target.value)}
                >
                  <Space direction="vertical" size={4} style={{ width: "100%" }}>
                    <Radio value="100_advance">
                      <span style={{ fontSize: 12 }}>100% Advance</span>
                    </Radio>

                    <Radio value="50_advance">
                      <span style={{ fontSize: 12 }}>
                        50% Advance + 50% Before Delivery
                      </span>
                    </Radio>

                    <Radio value="milestone">
                      <span style={{ fontSize: 12 }}>Milestone Based</span>
                    </Radio>

                    {customPaymentOptions.map((item, index) => (
                      <Radio key={index} value={`custom_${index}`}>
                        <span style={{ fontSize: 12 }}>{item}</span>
                      </Radio>
                    ))}

                    <Input.Search
                      size="small"
                      placeholder="Add custom payment term"
                      enterButton="Add"
                      value={customPaymentTerm}
                      onChange={(e) => setCustomPaymentTerm(e.target.value)}
                      onSearch={() => {
                        const value = customPaymentTerm.trim();
                        if (!value) return;

                        const newIndex = customPaymentOptions.length;

                        setCustomPaymentOptions((prev) => [...prev, value]);
                        setPaymentTerm(`custom_${newIndex}`);
                        setCustomPaymentTerm("");
                      }}
                      style={{ marginTop: 6 }}
                    />
                  </Space>
                </Radio.Group>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8} flex="1 1 0">
              <Card
                title={
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "rgba(11, 93, 148, 0.95)",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <BankOutlined
                      style={{
                        marginRight: 8,
                        color: "rgba(11, 93, 148, 0.95)",
                      }}
                    />
                    Bank Details
                  </span>
                }
                style={{ borderRadius: 12, height: "100%" }}
                headStyle={{
                  minHeight: 42,
                  padding: "0 12px",
                }}
                bodyStyle={{
                  padding: "10px 12px",
                  fontSize: 13,
                }}
              >
                <Select
                  size="small"
                  placeholder="Select bank account"
                  value={bankAc?.value}
                  style={{ width: "100%", marginBottom: 8 }}
                  options={bankAcOption}
                  onChange={(value, option) => {
                    setBankAc(option);
                  }}
                />



                {bankAc ? (
                  <>
                    <p style={{ marginBottom: 4, fontSize: 13 }}>
                      <b>Bank Name:</b> {bankAc.bank_name}
                    </p>
                    <p style={{ marginBottom: 4, fontSize: 13 }}>
                      <b>IFSC Code:</b> {bankAc.ifsc_code}
                    </p>
                    <p style={{ marginBottom: 4, fontSize: 13 }}>
                      <b>Account Name:</b> {bankAc.holder_name}
                    </p>
                    <p style={{ marginBottom: 4, fontSize: 13 }}>
                      <b>Account No:</b> {bankAc.ac_no}
                    </p>
                  </>
                ) : (
                  <Text type="secondary" style={{ fontSize: 13 }}>
                    Please select a bank account
                  </Text>
                )}
                <div
                  onClick={() => handleOpenAddBank(null)}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    marginTop: 12,
                    cursor: "pointer",
                    color: "#7c5cff",
                    fontWeight: 500,
                    fontSize: 13,
                  }}
                >
                  <PlusOutlined
                    style={{
                      fontSize: 12,
                      color: "#7c5cff",
                    }}
                  />
                  <span>Add Another Bank Account</span>
                </div>
              </Card>
              <Modal
                title={bankInitialValues?.id ? "Edit Bank" : "Add Bank"}
                open={bankModalOpen}
                onCancel={() => setBankModalOpen(false)}
                footer={null}
              >
                <AddBankData
                  initialValues={bankInitialValues}
                  onSubmit={handleBankSubmit}
                  onCancel={() => setBankModalOpen(false)}
                />
              </Modal>

            </Col>

            <Col xs={24} sm={12} md={8} flex="1 1 0">
              <Card
                title={
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "rgba(11, 93, 148, 0.95)",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <SafetyCertificateOutlined
                      style={{
                        marginRight: 8,
                        color: "rgba(11, 93, 148, 0.95)",
                      }}
                    />
                    Signature
                  </span>
                }
                style={{ borderRadius: 12, height: "100%" }}
                headStyle={{
                  minHeight: 42,
                  padding: "0 12px",
                }}
                bodyStyle={{
                  padding: "10px 12px",
                  fontSize: 13,
                }}
              >
                <Select
                  size="small"
                  placeholder="Select Signature"
                  value={dgSign?.value}
                  style={{ width: "100%", marginBottom: 8 }}
                  options={dgSignOption}
                  optionRender={(option) => option.data.label}
                  fieldNames={{ label: "title", value: "value" }}
                  onChange={(value, option) => setDGsign(option)}
                />
                {dgSign ? (
                  <div style={{ textAlign: "center", marginTop: 6 }}>
                    <img
                      src={`${ENDPOINT.base}/${dgSign.image_path}`}
                      alt="Signature"
                      style={{ maxWidth: "100%", maxHeight: 90, objectFit: "contain" }}
                    />
                  </div>
                ) : (
                  <Text type="secondary" style={{ fontSize: 13 }}>
                    Please select a signature
                  </Text>
                )}
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8} flex="1 1 0">
              <Card
                title={
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "rgba(11, 93, 148, 0.95)",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <FileTextOutlined
                      style={{
                        marginRight: 8,
                        color: "rgba(11, 93, 148, 0.95)",
                      }}
                    />
                    Notes To Customer
                  </span>
                }
                style={{ borderRadius: 12, height: "100%" }}
                headStyle={{
                  minHeight: 42,
                  padding: "0 12px",
                }}
                bodyStyle={{
                  padding: "10px 12px",
                  fontSize: 13,
                }}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Enter notes to customer"
                  value={notesToCustomer}
                  onChange={(e) => setNotesToCustomer(e.target.value)}
                  style={{
                    fontSize: 13,
                    resize: "none",
                  }}
                />
              </Card>
            </Col>
          </Row>
        </Col>

        {/* Scope + Analytics Section */}
        <Col xs={24}>
          <Row gutter={[16, 16]}>
            <Col xs={24} lg={16}>
              <Card style={{ borderRadius: 12 }} bodyStyle={{ padding: 0 }}>
                <Tabs
                  activeKey={activeTab}
                  onChange={setActiveTab}
                  items={[
                    {
                      key: "scope",
                      label: "Scope of Work",
                      children: (
                        <div style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={scope}
                            onChange={(value) => limitRichText(value, setScope)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },
                    {
                      key: "exclusions",
                      label: "Exclusions",
                      children: (
                        <div style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={exclusions}
                            onChange={(value) => limitRichText(value, setExclusions)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },
                    {
                      key: "assumptions",
                      label: "Assumptions",
                      children: (
                        <div style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={assumptions}
                            onChange={(value) => limitRichText(value, setAssumptions)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },

                    {
                      key: "support",
                      label: "Support & Warranty",
                      children: (
                        <div style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={supportWarranty}
                            onChange={(value) => limitRichText(value, setSupportWarranty)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },
                    {
                      key: "documents",
                      label: "Documents",
                      children: (
                        <div style={{ padding: 16 }}>
                          <Upload.Dragger
                            multiple
                            beforeUpload={(file) => {
                              setDocumentFiles((prev) => [...prev, file]);
                              return false;
                            }}
                            onRemove={handleDocumentRemove}
                            fileList={documentFiles}
                          >
                            <p>Drag & Drop files here or click to upload</p>
                          </Upload.Dragger>
                        </div>
                      ),
                    },
                    {
                      key: "notes",
                      label: "Internal Notes",
                      children: (
                        <div style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={internalNotes}
                            onChange={(value) => limitRichText(value, setInternalNotes)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },

                    {
                      key: "delivery_timeline",
                      label: "Delivery Timeline",
                      children: (
                        <div className="scope-quill" style={{ padding: 16 }}>
                          <ReactQuill
                            theme="snow"
                            value={deliveryTimeline}
                            onChange={(value) => limitRichText(value, setDeliveryTimeline)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },
                    {
                      key: "customer_notes",
                      label: "Customer Notes",
                      children: (
                        <div
                          ref={customerNotesRef}
                          style={{ padding: 16 }}
                        >
                          <ReactQuill
                            theme="snow"
                            value={customerNotes}
                            onChange={(value) => limitRichText(value, setCustomerNotes)}
                            modules={scopeQuillModules}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: 12,
                              color: "#999",
                              marginTop: 5,
                            }}
                          >
                            {scope
                              .replace(/<[^>]+>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim().length}{" "}
                            / 344
                          </div>
                        </div>
                      ),
                    },
                  ]}
                />
              </Card>
            </Col>

            <Col xs={24} lg={8}>
              <Card
                title={
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#0B5D94",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <BarChartOutlined style={{ marginRight: 8, color: "#0B5D94" }} />
                    Quotation Analytics
                  </span>
                }
                style={{ borderRadius: 12, height: "100%" }}
                headStyle={{
                  minHeight: 42,
                  padding: "0 12px",
                  background: "#fff",
                }}
                bodyStyle={{
                  padding: 12,
                }}
              >
                <Row gutter={[12, 12]}>
                  {[
                    {
                      label: "Total Value",
                      value: `₹ ${roundedTotal.toLocaleString("en-IN")}`,
                    },
                    {
                      label: "Probability",
                      value: `${probabilityPercent}%`,
                      color:
                        probabilityPercent >= 90
                          ? "#16a34a"
                          : probabilityPercent >= 40
                            ? "#f59e0b"
                            : "#ef4444",
                    },
                    {
                      label: "Expected Revenue",
                      value: `₹ ${expectedRevenue.toLocaleString("en-IN")}`,
                    },
                    {
                      label: "Weighted Value",
                      value: `₹ ${weightedValue.toLocaleString("en-IN")}`,
                    },
                    {
                      label: "Quotation Age",
                      value: `${quotationAge} Days`,
                    },
                    {
                      label: "Last Activity",
                      value: dayjs().format("DD MMM YYYY"),
                    },
                    {
                      label: "Next Follow-up",
                      value: currentFollowUp?.date
                        ? dayjs(currentFollowUp.date).format("DD MMM YYYY")
                        : "-",
                    },
                  ].map((item, index) => (
                    <Col xs={24} sm={12} md={index > 3 ? 8 : 6} key={index}>
                      <div
                        style={{
                          border: "1px solid #eef0f5",
                          borderRadius: 10,
                          padding: "12px 10px",
                          minHeight: 68,
                          background: "#fff",
                        }}
                      >
                        <Text
                          type="secondary"
                          style={{
                            fontSize: 11,
                            fontWeight: 500,
                            display: "block",
                            marginBottom: 6,
                          }}
                        >
                          {item.label}
                        </Text>

                        <div
                          style={{
                            fontSize: 14,
                            fontWeight: 500,
                            color:
                              typeof item.value === "string"
                                ? item.color || "#2a2b2c"
                                : undefined,
                          }}
                        >
                          {item.value}
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>

      </Row>

      <Card
        title={
          <span
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "rgba(11, 93, 148, 0.95)",
            }}
          >
            Follow-up Details
          </span>
        }
        style={{ marginTop: 10, borderRadius: 8 }}
        headStyle={{
          padding: "4px 10px",
          minHeight: 36,
        }}
        bodyStyle={{
          padding: "6px 10px",
        }}
      >
        {/* Input Fields */}
        <Row gutter={[8, 8]}>
          <Col xs={24} md={4}>
            <Form.Item label="Follow-up Date" style={{ marginBottom: 0 }}>
              <DatePicker
                size="small"
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                value={followUpInput.date}
                onChange={(value) =>
                  setFollowUpInput({ ...followUpInput, date: value })
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={4}>
            <Form.Item label="Follow-up Type" style={{ marginBottom: 0 }}>
              <Select
                size="small"
                allowClear
                placeholder="Select type"
                options={followUpTypeOptions}
                value={followUpInput.follow_up_type}
                onChange={(value) =>
                  setFollowUpInput({
                    ...followUpInput,
                    follow_up_type: value,
                  })
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={16}>
            <Form.Item label="Summary" style={{ marginBottom: 0 }}>
              <Input.TextArea
                rows={1}
                autoSize={{ minRows: 1, maxRows: 3 }}
                placeholder="Enter follow-up summary"
                value={followUpInput.summary}
                onChange={(e) =>
                  setFollowUpInput({
                    ...followUpInput,
                    summary: e.target.value,
                  })
                }
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Button Row */}
        <Row justify="end" style={{ marginTop: 10, marginBottom: 10 }}>
          <Button
            type="primary"
            size="small"
            onClick={handleAddFollowUp}
            style={{
              backgroundColor: "rgba(14, 93, 146, 0.95)",
              borderColor: "rgba(14, 93, 146, 0.95)",
            }}
          >
            + Next Follow-Up
          </Button>
        </Row>

        {followUps.length > 0 && (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: 16,
            }}
          >
            <thead>
              <tr style={{ background: "#fafafa" }}>
                <th style={{ padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                  Follow-up Date
                </th>
                <th style={{ padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                  Follow-up Type
                </th>
                <th style={{ padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                  Summary
                </th>
                <th style={{ padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                  Follow-up By
                </th>
              </tr>
            </thead>

            <tbody>
              {followUps.map((item, index) => (
                <tr key={index}>
                  <td style={{ padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                    {item.date ? dayjs(item.date).format("DD-MM-YYYY") : "-"}
                  </td>
                  <td style={{ padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                    {item.follow_up_type || "-"}
                  </td>
                  <td style={{ padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                    {item.summary || "-"}
                  </td>
                  <td style={{ padding: "6px 8px", fontSize: 12, border: "1px solid #f0f0f0" }}>
                    {item.follow_up_by || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>

      <Modal
        title="Edit Terms & Conditions"
        open={tcModalOpen}
        onCancel={() => setTcModalOpen(false)}
        onOk={() => {
          setEditedTCContent(tempTcContent);

          setSelectedValue((prev) => ({
            ...prev,
            data: tempTcContent,
          }));

          setTcModalOpen(false);
        }}
        width={900}
      >
        <ReactQuill
          theme="snow"
          value={tempTcContent}
          onChange={(value) => limitRichText(value, setTempTcContent)}
          modules={scopeQuillModules}
        />
        <div
          style={{
            textAlign: "right",
            fontSize: 12,
            color: "#999",
            marginTop: 5,
          }}
        >
          {scope
            .replace(/<[^>]+>/g, "")
            .replace(/&nbsp;/g, " ")
            .trim().length}{" "}
          / 344
        </div>
      </Modal>



      <Modal
        width={800}
        title={
          <Typography.Title level={4}>Add Payment for: {quotationNo}</Typography.Title>
        }
        open={paymentModalOpen}
        onCancel={() => setPaymentModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        {/* pass quotationNo only */}
        {quotationNo && <CreatePayment quotationNo={quotationNo} grandTotal={grandTotal} />}
      </Modal>

    </>
  );
});

export default AddQuotationData;